import { Pipe, PipeTransform } from '@angular/core';
const status = {
    "ACTIVE": "Ativo",
    "DRAFT": "Rascunho",
    "CLOSED": "Fechado",
	"INACTIVE": "Desativada",

}
@Pipe({
    name: 'challengeStatus',
    standalone: false
})
export class ChallengeStatusPipe implements PipeTransform {
	transform(text: string) {
		if (text.length) {
			return status[text];
		}
        return ""
	}
}
